import React, {Component} from 'react'

import {
  IconButton,
  Snackbar,
} from 'material-ui'

import CloseIcon from 'material-ui-icons/Close';

export default class Snack extends Component{
  // openSnack=()=>{
  //   this.setState({snack:this.props.messageStatus,snackMessage:this.props.message})
  // }
  render(){
    const {snackStatus,snackMessage,closeSnack} = this.props;
    return (
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={snackStatus}
        onRequestClose={closeSnack}
        SnackbarContentProps={{
          'aria-describedby': 'message-id',
        }}
        autoHideDuration={3000}
        message={<span id="message-id">{snackMessage}</span>}
        action={[
          <IconButton
            key="close"
            aria-label="Close"
            color="inherit"
            onClick={closeSnack}
          >
            <CloseIcon />
          </IconButton>,
        ]}
      />
    )
  }
}


// import Snack from '../components/Snack'
// closeSnack=()=>{
//   this.setState({snackStatus:false,snackMessage:''})
// }
// <Snack
//   snackStatus={this.state.snackStatus}
//   snackMessage={this.state.snackMessage}
//   closeSnack={()=>{this.closeSnack()}}
// />



// WEBPACK FOOTER //
// ./src/components/Snack.js